import { useQuery } from "@tanstack/react-query";
import { OpenAPI } from "@/api/SolarCloudApi";

export type MilestoneSiteDetail = {
  name: string;
  panels: number;
  date: string | null;
};

export type MilestoneDetail = {
  panelCount: number;
  sites: MilestoneSiteDetail[];
};

export type TrackerSummary = {
  depositReceived: MilestoneDetail;
  siteLocated: MilestoneDetail;
  siteLockedIn: MilestoneDetail;
  installCommencing: MilestoneDetail;
  installComplete: MilestoneDetail;
  fullSystemActive: MilestoneDetail;
  readyToGo: MilestoneDetail;
};

export async function fetchTrackerSummary(): Promise<TrackerSummary> {
  const token = typeof OpenAPI.TOKEN === "function" ? await OpenAPI.TOKEN({ method: "GET", url: "" }) : OpenAPI.TOKEN;
  const response = await fetch(`${OpenAPI.BASE}/api/tracker/order-tracker`, {
    headers: {
      ...OpenAPI.HEADERS,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch order tracker status");
  }
  return response.json();
}

export function useTrackerSummary() {
  return useQuery({
    queryKey: ["orderTrackerSummary"],
    queryFn: fetchTrackerSummary,
    refetchInterval: 60 * 1000,
  });
}
